<template>
  <div class="home-view">
    <section class="form">
      <div class="container">
        <h1 class="title-default">Informe para imposto de renda</h1>

        <form @submit.prevent="submit">
          <div class="fieldset" v-if="years && years.length && !loading">
            <label for="sel_year">Demonstrativo referente ao ano:</label>

            <select id="sel_year" v-model="sel_year" @change="submit">
              <option value="">Selecione</option>
              <option v-for="item in years" :key="item" :value="item">{{ item }}</option>
            </select>
          </div> <!-- /fieldset -->

          <p v-if="loading || error" class="callback" :class="{ '-error': !!error }">{{ error || 'Carregando...' }}</p>
        </form> <!-- /form -->
      </div> <!-- /.container -->
    </section> <!-- /.form -->
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'informe-ir',

  data () {
    const data = {
      loading: true,
      error: '',

      years: [],
      sel_year: '',

      base64: ''
    }

    return data
  }, // data()

  mounted () {
    this.getYears()
  }, // mounted()

  methods: {
    async getYears () {
      try {
        const xhr = await PagesService.getIRPFAnoAnterior(this.contrato)

        if (xhr && xhr.base64) {
          this.years.push(new Date().getFullYear() - 1)
          this.base64 = xhr.base64
        } else {
          this.error = 'Não existem informe disponível referente ao ano anterior'
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    }, // getYears()

    async submit () {
      try {
        if (this.loading) return

        this.loading = true

        // const pdf = await PagesService.getIRPF(this.contrato, this.sel_year)

        if (this.base64) {
          this.openPDF(this.base64)
          this.sel_year = ''
        } else {
          this.error = 'Falha ao abrir o informe.'
        }
      } catch (e) {
        this.error = 'Falha ' + e
      } finally {
        this.loading = false
      }
    }, // submit()

    openPDF (base64 = '') {
      if (!base64) return

      let newBlob = this.convertBase64toBlob(base64, 'application/pdf')

      // IE
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        // this.toggleModalAnt()
        return
      }

      // Cria elemento e simula clique
      const data = window.URL.createObjectURL(newBlob)

      let link = document.createElement('a')
      link.href = data
      link.download = 'file.pdf'

      if (typeof InstallTrigger !== 'undefined') { // se for FF
        let clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: false
        })

        link.dispatchEvent(clickEvent)
      } else {
        link.click()

        setTimeout(() => {
          window.URL.revokeObjectURL(data)
        }, 100)
      }
    }, // openPDF()

    convertBase64toBlob (content, contentType) {
      contentType = contentType || ''

      let sliceSize = 512
      let byteCharacters = window.atob(content) // Converte o base64 para o binário
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)
        let byteNumbers = new Array(slice.length)

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      let blob = new Blob(byteArrays, {
        type: contentType
      }) // Cria o Blob

      return blob
    } // convertBase64toBlob()
  }, // methods

  computed: {
    contrato () {
      return this.$store.state.contratoAtual.codigo
    }
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section
    &.form form
      .fieldset
        display: flex
        align-items: center
        justify-content: center

        @media (max-width: 1024px)
          flex-direction: column

          select
            margin-top: 20px !important

        select
          height: 40px
          width: 140px
          margin: 0 0 0 10px

      .callback
        text-align: center
        font-size: 22px
        text-transform: uppercase
        font-weight: 600
        color: map-get($colors, green)

        &.-error
          color: map-get($colors, red)
</style>
